import React, { PureComponent } from "react";
import Upload from "antd/lib/upload";
import Icon from "antd/lib/icon";
import message from "antd/lib/message";

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isValidSize = (file.size / 1024 / 1024) * 68 < 1;
  if (!isValidSize) {
    message.error(`File should be less than 15 kB`);
  }
  return isValidSize;
}

class ImageUpload extends PureComponent {
  handleChange = info => {
    const { onChange } = this.props;
    if (info && info.file && info.file.originFileObj)
      getBase64(info.file.originFileObj, imageUrl => {
        if (imageUrl) onChange(imageUrl);
      });
  };

  render() {
    const { image, disabled } = this.props;
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div>Upload</div>
      </div>
    );

    if (disabled) {
      return image ? (
        <img src={image} alt="word icon" style={{ width: 64, height: 64 }} />
      ) : (
        <div style={{ width: 64, height: 64 }} />
      );
    }
    return (
      <Upload
        name="word icon"
        listType="picture-card"
        showUploadList={false}
        action="/"
        customRequest={() => {}}
        beforeUpload={file => beforeUpload(file)}
        onChange={this.handleChange}
      >
        {image ? (
          <img src={image} alt="word icon" style={{ width: 64, height: 64 }} />
        ) : (
          uploadButton
        )}
      </Upload>
    );
  }
}

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/ImageUpload/index.js